export var NegativeCampaignDsaTarget={properties:{'bulk-upload-type':{type:'string',value:'Campaign Negative Dynamic Search Ad Target'}}};